angular.module('homebot.directives')

  .directive('cashoutSection', ['Dictionary', function(Dictionary){
    return {
      restrict: 'A',
      controllerAs: 'cashoutCtrl',
      bindToController: {
        agent: '=',
        loans: '=',
        home: '=',
        userId: '@',
      },
      scope: {},
      templateUrl: '/homes/templates/section-cashout.html',

      controller: function(){
        const INITIAL_LTV = 80;
        const MINIMUM_LTV_TO_SUGGEST_CASHOUT = 80;
        const MINIMUM_LTV_TO_DISPLAY_SLIDER = 77;
        var modifiedHome = {};
        var loans;
        var dictionary = new Dictionary();
        var ctrl = this;

        ctrl.lookup = function(prop,args,home){
          var home = home || modifiedHome;
          return dictionary[prop](home,args);
        };

        ctrl.update = function(){
          modifiedHome = _.cloneDeep(ctrl.home);
          loans = _.isArray(ctrl.loans) ? ctrl.loans : [ctrl.loans];
          modifiedHome.loans = loans;
        };

        ctrl.toggle = function(prop){
          ctrl[prop] = !ctrl[prop];
        };

        ctrl.ltv = INITIAL_LTV;
        ctrl.minimumLtvToSuggestCashout = MINIMUM_LTV_TO_SUGGEST_CASHOUT;
        ctrl.minimumLtvToDisplaySlider = MINIMUM_LTV_TO_DISPLAY_SLIDER;
      },

      link: function($scope, el, attrs, ctrl){
        $scope.$watchCollection('cashoutCtrl.loans', ctrl.update);
      }
    }

  }]);
